<template>
  <q-card flat>
    <q-card-section class="no-padding fixed-header-position bg-white">
      <q-banner class="bg-primary text-white">
        ثبت سفارش خرده فروشی
      </q-banner>
      <OrderSearchPanel :is-shop-order="true"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <CustomersList title="" :is-dialog="false" :items="[]" :buy-list="false" @customerSelected="customerSelected"  />
    </q-card-section>
    <q-card-section class="no-padding">
      <ProductSearchResults :is-shop-order="true"/>
    </q-card-section>
  </q-card>
</template>

<script>
import OrderSearchPanel from "@/components/orders/OrderSearchPanel.vue";
import ProductSearchResults from "@/components/products/ProductSearchResults.vue";
import {mapActions} from "vuex";
import EventBus from "@/event-bus";
import CustomersList from "@/components/customers/CustomersList.vue";

export default {
  name: "OrdersList",
  components: {CustomersList, ProductSearchResults, OrderSearchPanel},
  methods: {
    ...mapActions({
      getOrderInfo: 'Orders/getOrderBySaleNum'
    }),
    customerSelected(){

    }
  },
  created() {
    if (this.$route.params.id) {
      this.getOrderInfo(this.$route.params.id).then((res) => {
        EventBus.$emit('invoke-selected-customer', JSON.parse(res.CustomerInfo)[0]);
        EventBus.$emit('invoke-selected-sale_num', this.$route.params.id);
        EventBus.$emit('invoke-selected-exists-orderList', JSON.parse(res.OrderDetails));
        EventBus.$emit('invoke-selected-exists-order-info', JSON.parse(res.OrderHeaderInfo)[0]);
      })
    }
  },
  meta() {
    return {
      title: "ثبت سفارش"
    }
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000
}
</style>